angular.module('leanlaw').directive('qbConnections', ['lists', function (lists) {
  return {
    restrict: "EA",
    template: require("./views/qbConnections.html"),
    scope: {
      me: "=",
      showConnectionStatusesFilter: "=",
      showConnectionStatuse: "=",
      filter: "=",
      changeConnectionStatuses: "=",
      validating: "=",
      clients: "="
    },
    link: $scope => {
      $scope.quickBooksStatuses = lists.quickBooksStatuses;
    }
  };
}]);